import { Box, Flex, Grid, GridItem, Image, Input, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, useDisclosure, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, FormControl, FormLabel, Button, InputGroup, InputLeftElement, Textarea, Checkbox, Center, Spinner, } from '@chakra-ui/react'
import MyDiv from './candidateMaster.style';
import { CustomButton, CustomPagination, CustomToast, ActionEditIcon, CustomTable } from '../../../../../components';
import { useEffect, useState } from 'react';
import PlusIcon from "../../../../../assets/images/Vector.svg";

import { Search2Icon } from '@chakra-ui/icons';
import { ICandidate } from './model';
import { useFetch } from '../../../../../hooks/useFetch';
import { Column } from '../../../../../components/CustomTable/customTable';

const Header = [
  { id: 1, head: 'S. No' },
  { id: 2, head: 'Name' },
  { id: 3, head: 'Email' },
  { id: 4, head: 'Phone' },
  { id: 5, head: 'Address' },
  { id: 6, head: 'Experience (in Months)' },
  { id: 7, head: 'Current Salary' },
  { id: 8, head: 'Expected Salary' },
  { id: 9, head: 'Actions' },
];

const CandidateMaster = () => {
  const [candidateLists, setCandidateLists] = useState<ICandidate[]>([]);
  const [DrawerOpen, setDrawerOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const { addToast } = CustomToast();
  const { fetchApi, loading } = useFetch(addToast);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalCount, setTotalCount] = useState<number>(0);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [lazyParams, setLazyParams] = useState({ first: 0, rows: 10, page: 0, sortField: '', sortOrder: 1, });
  const [currentCandidate, setCurrentCandidate] = useState<ICandidate>({
    id: 0,
    candidate_Name: '',
    email: '',
    phone: '',
    address: '',
    experience: false,
    experience_In_Month: 0,
    current_Salary: 0,
    expected_Salary: 0
  });

  const handleAddNewCandidate = () => {
    setIsEditMode(false);
    setCurrentCandidate({
      id: 0,
      candidate_Name: '',
      email: '',
      phone: '',
      address: '',
      experience: false,
      experience_In_Month: 0,
      current_Salary: 0,
      expected_Salary: 0
    });
    setDrawerOpen(true);
  };

  const handleEditCandidate = (candidateLists: ICandidate) => {
    setIsEditMode(true);
    setSelectedId(candidateLists.id);
    setCurrentCandidate(candidateLists);
    setDrawerOpen(true);
  };

  const handleInputChange = (e: any) => {
    const { name, value, type } = e.target;
    const checked = (e.target as HTMLInputElement).checked;
    if (name === "candidate_Name" && !/^[A-Za-z\s]*$/.test(value)) {
      return;
    }
    if (name === "phone" && !/^\d*$/.test(value)) {
      return;
    }
    setCurrentCandidate(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };


  const handleSubmit = async () => {
    if (!currentCandidate.candidate_Name.trim()) {
      addToast({ message: "Please enter Candidate Name", status: "warning" });
      return;
    }
    if (!currentCandidate.email.trim()) {
      addToast({ message: "Please enter Email", status: "warning" });
      return;
    }
    if (!currentCandidate.phone.trim()) {
      addToast({ message: "Please enter Phone Number", status: "warning" });
      return;
    }
    if (!currentCandidate.address.trim()) {
      addToast({ message: "Please enter Address", status: "warning" });
      return;
    }

    if (currentCandidate.experience) {
      if (!currentCandidate.experience_In_Month) {
        addToast({ message: "Please enter Experience in Months", status: "warning" });
        return;
      }
      if (!currentCandidate.current_Salary) {
        addToast({ message: "Please enter Current Salary", status: "warning" });
        return;
      }
      if (!currentCandidate.expected_Salary) {
        addToast({ message: "Please enter Expected Salary", status: "warning" });
        return;
      }
    }
    if (isEditMode) {
      const response = await fetchApi(`Hrlense_CandidateMast/${currentCandidate.id}`, "PUT",
        {
          id: currentCandidate.id,
          candidate_Name: currentCandidate.candidate_Name,
          email: currentCandidate.email,
          phone: currentCandidate.phone,
          address: currentCandidate.address,
          experience_In_Month: currentCandidate.experience_In_Month,
          current_Salary: currentCandidate.current_Salary,
          expected_Salary: currentCandidate.expected_Salary,
        }, null, "Candidate updated successfully");

      if (response) setCandidateLists((prev) => prev.map((candidateLists) => (candidateLists.id === selectedId ? currentCandidate : candidateLists)));
    } else {
      const response = await fetchApi<ICandidate>("Hrlense_CandidateMast", "POST",
        {
          candidate_Name: currentCandidate.candidate_Name,
          email: currentCandidate.email,
          phone: currentCandidate.phone,
          address: currentCandidate.address,
          experience_In_Month: currentCandidate.experience_In_Month,
          current_Salary: currentCandidate.current_Salary,
          expected_Salary: currentCandidate.expected_Salary,
        }, null, "Candidate added successfully");
      if (response) setCandidateLists((prev) => [...prev, response]);
    }
    setDrawerOpen(false);
  };

  const pageCount = Math.ceil(totalCount / lazyParams.rows);

  const handlePageClick = ({ selected }: { selected: number }) => {
    const updatedParams = {
      ...lazyParams,
      page: selected,
      first: selected * lazyParams.rows,
    };
    setLazyParams(updatedParams);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchTerm]);
  useEffect(() => {
    setLazyParams(prev => ({
      ...prev,
      page: 0,
      first: 0
    }));
  }, [debouncedSearch]);
  useEffect(() => {
    loadMaster();
  }, [lazyParams]);
  const loadMaster = async () => {
    try {
      const query = new URLSearchParams({
        lazyParams: JSON.stringify(lazyParams),
        filter: searchTerm || "",
      }).toString();

      const response = await fetchApi<{ candidateLists: ICandidate[]; totalRecord: number }>('Hrlense_CandidateMast', 'GET', null, query, '');
      if (response) {
        setCandidateLists(response.candidateLists);
        setTotalCount(response.totalRecord);
      }
    } catch (error) {
      console.error('Failed to fetch branches:', error);
    }
  };

  return (
    <MyDiv>

      <Flex className="page_heading flex_header" >
        <Text className="font-poppins text_semibold text_3xl">Candidate Master</Text>
        <Flex gap={2}>
          <InputGroup width="197px" height="37px">
            <InputLeftElement pointerEvents="none">
              <Search2Icon color="rgba(102, 112, 133, 1)" />
            </InputLeftElement>
            <Input
              type="text"
              placeholder="Search Candidate Name...."
              value={searchTerm}

              onChange={(e) => setSearchTerm(e.target.value)}
            />

          </InputGroup>
          <CustomButton title="Add New Candidate" className=' btn font-poppins text_sm text_medium' rightIcon={<Image src={PlusIcon} className='logo' />} onClick={handleAddNewCandidate} />
        </Flex>
      </Flex>
      <Box position="relative" minH="300px">
        {loading && (
          <Center position="absolute" inset={0} zIndex={1}>
            <Spinner size="xl" color="#006838" />
          </Center>
        )}
        <Grid className='grid_container'>
          <GridItem colSpan={12}>
            <CustomTable value={candidateLists} >
              <Column header="S. No" body={(_, index) => index + 1} />
              <Column header="Name" field="candidate_Name" />
              <Column header="Email" field="email" />
              <Column header="Phone" field="phone" />
              <Column header="Address" field="address" />
              <Column header="Experience (in Months)" field="experience_In_Month" />
              <Column header="Current Salary" field="current_Salary" />
              <Column header="Expected Salary" field="expected_Salary" />
              <Column
                header="Actions"
                body={(row: any) => (<ActionEditIcon onClick={() => handleEditCandidate(row)} />
                )}
              />
            </CustomTable>

          </GridItem>
        </Grid>
      </Box>
      <Drawer isOpen={DrawerOpen} placement="right" onClose={() => setDrawerOpen(false)} size="sm">
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader borderBottomWidth="1px">{isEditMode ? 'Edit Candidate' : 'Add New Candidate'}</DrawerHeader>
          <DrawerBody display="flex" flexDirection="column" justifyContent="space-between" height="100%">
            <Box py={4}>
              <FormControl mb={4} isRequired>
                <FormLabel>Name</FormLabel>
                <Input name="candidate_Name" value={currentCandidate.candidate_Name} onChange={handleInputChange} placeholder="Enter name" type='text' />
              </FormControl>
              <FormControl mb={4} isRequired>
                <FormLabel>Email</FormLabel>
                <Input name="email" value={currentCandidate.email} onChange={handleInputChange} placeholder="Enter email" type='email' />
              </FormControl>
              <FormControl mb={4} isRequired >
                <FormLabel>Phone</FormLabel>
                <Input name="phone" value={currentCandidate.phone} onChange={handleInputChange} placeholder="Enter phone number" type='tel' />
              </FormControl>
              <FormControl mb={4} isRequired>
                <FormLabel>Address</FormLabel>
                <Textarea name="address" value={currentCandidate.address} onChange={handleInputChange} placeholder="Enter address" />
              </FormControl>
              <Checkbox name="experience" isChecked={currentCandidate.experience} onChange={handleInputChange}></Checkbox>
              {currentCandidate.experience && (
                <>
                  <FormControl mb={4} isRequired>
                    <FormLabel>Experience in Months </FormLabel>
                    <Input name="experience_In_Month" value={currentCandidate.experience_In_Month} onChange={handleInputChange} placeholder="Enter experience in Months" />
                  </FormControl>
                  <FormControl mb={4} isRequired>
                    <FormLabel>Current Salary</FormLabel>
                    <Input name="current_Salary" value={currentCandidate.current_Salary} onChange={handleInputChange} placeholder="Enter current salary" type='number' />
                  </FormControl>
                  <FormControl mb={4} isRequired>
                    <FormLabel>Expected Salary</FormLabel>
                    <Input name="expected_Salary" value={currentCandidate.expected_Salary} onChange={handleInputChange} placeholder="Enter expected salary" type='number' />
                  </FormControl>
                </>)}
            </Box>
            <Flex justify="flex-end" mt={4} gap={2}>
              <Button className="font-poppins text_sm text_medium" onClick={() => setDrawerOpen(false)} style={{ backgroundColor: '#D92F34', color: 'white' }}>Cancel</Button>
              <Button onClick={handleSubmit} className="font-poppins text_sm text_medium" style={{ backgroundColor: '#006838', color: 'white' }}>{isEditMode ? "Update Candidate" : "Add Candidate"}</Button>
            </Flex>
          </DrawerBody>
        </DrawerContent>
      </Drawer>

      <CustomPagination pageCount={pageCount} rowsPerPageOptions={[10, 50, 100, 200]} handlePageClick={handlePageClick} rowsPerPage={lazyParams.rows}
        setRowsPerPage={(rows) => setLazyParams(prev => ({ ...prev, rows, page: 0, first: 0, }))}
        totalRecords={totalCount}
        currentPage={lazyParams.page}
      />
    </MyDiv>
  )
}

export default CandidateMaster;
